import apiClient, { ApiError } from '@/utility/apiClient'
import { handleApiError } from '@/lib/api/utils/errorHandler'

export interface SuggestCompany {
  id: string
  name: string
  openUrl: string
  imageUrl: string
  enName?: string
  kana?: string
}

export interface SuggestTag {
  id: string
  name: string
  slug: string
}

export interface SuggestResponse {
  companies: SuggestCompany[]
  tags: SuggestTag[]
}

/**
 * サジェスト関連のAPIコール
 */
export const SuggestService = {
  /**
   * 検索用のサジェストデータを取得
   */
  getSuggestData: async (): Promise<SuggestResponse> => {
    try {
      const url = 'suggest'
      const response = await apiClient.request('GET', url)
      return response.data
    } catch (error) {
      // リクエストキャンセルは無視して空のレスポンスを返す
      if (error instanceof ApiError && error.statusText === 'Cancelled') {
        return { companies: [], tags: [] }
      }
      handleApiError(error)
    }
  },
}
